import Cookies from 'js-cookie';

const TokenKey = 'token';
const UserKey = 'user';

export function getToken(): string {
    const token = Cookies.get(TokenKey);
    if (token) {
        return token as string
    }
    return ""
}

type userInfo = {
    name: string,
    email: string,
    tenantId: string,
    sso: string,
    provider: string,
}

export function getUserInfo(): userInfo {
    const userString = Cookies.get(UserKey);
    if (!userString) {
        return {
            name: "",
            email: "",
            tenantId: "",
            sso: "",
            provider: "",
        }
    }
    console.log('userString', userString)
    const user =JSON.parse(decodeURI(userString)) as userInfo
    console.log('user', user)
    return user

}
